import { createApp, h } from "vue"
import NykAlert from "./NykAlert"

const el = ".nyk-component--alert"

export default function (Store) {
  const DOM = document.querySelectorAll(el)
  if (DOM.length) {
    DOM.forEach((NykAlertDOM) => {
      const type = NykAlertDOM.dataset.type
      const message = NykAlertDOM.dataset.message

      const component = createApp({
        render() {
          return h(NykAlert, { type }, { default: () => message })
        }
      }).use(Store)

      component.mount(NykAlertDOM)
    })
  }
}